import type { BreadcrumbList } from "@decocms/apps-commerce/types"

export interface Props {
    itemListElement: BreadcrumbList['itemListElement']
}

const rel = (url: string) => {
    try { return new URL(url).pathname }
    catch { return url }
}

function Breadcrumb({ itemListElement = [] }: Props) {
    return (
        <ul data-prerender className='flex items-center text-xs'>
            <li>
                <a href='/' className='text-black'>
                    Miess
                </a>
            </li>
            {itemListElement
                .filter(({ name, item }) => name && item)
                .map(({ name, item: rawItem }, index, { length: totalItems }) => {
                    const item = rawItem!.startsWith("http") ? rel(rawItem!) : rawItem
                    return (
                    <li key={item ?? `${name}-${index}`} className='shrink-0'>
                        <span className="after:text-black after:content-['\2192'] after:inline after:text-[9px]/4 after:m-[2px_9px_0_9px] after:align-top" />
                        {index === totalItems - 1
                            ? (
                                <a
                                    className='underline underline-offset-2 text-red-wine font-bold capitalize'
                                    href={item}
                                >
                                    {name}
                                </a>
                            )
                            : (
                                <a href={item} className='text-black'>
                                    {name}
                                </a>
                            )}
                    </li>
                    )
                })}
        </ul>
    )
}

export default Breadcrumb
